import { cn } from "@repo/ui/lib/utils";
import type { ComponentProps } from "react";

export const Token = ({
  children,
  className,
  ...props
}: ComponentProps<"span">) => {
  if (!children) return null;
  return (
    <span
      className={cn(
        "inline-flex h-4 min-w-4 items-center justify-center rounded border px-1 pt-px font-mono text-[10px]! text-muted-foreground tabular-nums leading-none",
        className,
      )}
      {...props}
    >
      {children}
    </span>
  );
};
